import { Controller } from "@hotwired/stimulus"

// Mobile-only collapse/expand for a numbered "How it works" step.
// Desktop CSS hides the chevron and always shows the description; the
// controller still toggles a class so aria-expanded reflects state.
export default class extends Controller {
  toggle() {
    const expanded = this.element.classList.toggle("is-expanded")
    const button = this.element.querySelector(
      "[data-action~='seniors-step#toggle']"
    )
    if (button) button.setAttribute("aria-expanded", expanded.toString())
  }
}
